module.exports = __webpack_public_path__ + "static/media/spin.5f2b4a9c.svg";